<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { usePlural } from "#/utils/usePlural";
import FormInput from "#/form/FormInput.vue";

interface Props {
  readonly phone: string;
  readonly isLoading?: boolean;
  readonly errorMessage?: string;
}

const emits = defineEmits<{
  "form:approve": [code: string];
  "form:code-resend": [];
  "change-phone": [];
}>();

const props = defineProps<Props>();

const SECONDS_FOR_RESEND = 30;

const { pluralizeSeconds } = usePlural();
const readOnlyPhone = ref(props.phone);
const codeInput = ref();
const timerId = ref();
const time = ref(SECONDS_FOR_RESEND);

const approve = () => {
  emits("form:approve", codeInput.value);
};

const _resendCode = async () => {
  codeInput.value = "";
  emits("form:code-resend");
  time.value = SECONDS_FOR_RESEND;
  startTimer();
};

const startTimer = () => {
  timerId.value = setInterval(() => {
    time.value--;

    if (time.value <= 1) {
      clearInterval(timerId.value);
      timerId.value = null;
    }
  }, 1000);
};

onMounted(() => startTimer());

onUnmounted(() => {
  clearInterval(timerId.value);
  timerId.value = null;
});
</script>

<template>
  <span class="color-dark flex mb-20 text-small justify-center">
    Отправили SMS c кодом на указанный номер, для подтверждения
  </span>

  <form-input
    v-model="readOnlyPhone"
    label="Новый номер телефона"
    class="mb-20"
    disabled
  />

  <form-input
    v-model="codeInput"
    label="Код подтверждения"
    placeholder="Введите код"
    @keyup.enter="approve"
  />

  <div class="flex justify-between mb-20">
    <div>
      <span v-if="timerId" class="color-passive">
        Получить новый код ({{ pluralizeSeconds(time) }})
      </span>
      <a v-else href="javascript:void(0)" @click.stop="_resendCode">
        Получить новый код
      </a>
    </div>

    <a class="cursor-pointer" @click="emits('change-phone')">
      Изменить номер
    </a>
  </div>

  <div v-if="props.errorMessage" class="color-error mb-20">
    {{ props.errorMessage }}
  </div>

  <button
    type="submit"
    class="w-full flex justify-center counter-form__submit btn"
    :class="props.isLoading ? 'tag-disable' : 'tag-primary'"
    :disabled="props.isLoading"
    @click="approve"
  >
    Подтвердить
  </button>
</template>
